import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { LogService, RouteHelperService } from '@app/services';
import { Subscription } from 'rxjs';


/**
 * A general resource unavailable component that is drives the /resun route.  Sort of a "404" page for components.
 */
@Component({
    selector: "resun",
    templateUrl: "./resource-unavailable.component.html",
    styleUrls: ["./resource-unavailable.component.less"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: []
})
export class ResourceUnavailableComponent implements OnInit, OnDestroy {
  private readonly _componentName = 'ResourceUnavailableComponent';
  private _state: any;
  private _title : string = 'Resource Not Available'

  public resourceUnavailableState$: Subscription;

  constructor(private log: LogService, private routeHelper: RouteHelperService) {
    console.log(`${this._componentName}.CTOR`);

    this.resourceUnavailableState$ = this.routeHelper.resourceUnavailableState.subscribe((s) => {
      this.state = s;

      console.log(`${this._componentName}.resourceUnavailableState = `, s);
    });
  }

  ngOnInit() {}

  /**
   * Called once, before the instance is destroyed.
   */
  ngOnDestroy(): void {
    if (this.resourceUnavailableState$) {
      this.resourceUnavailableState$.unsubscribe();
    }
  }

  private get verboseLogging(): boolean {
    return this.log.verboseLogging;
  }

  public get message(): boolean {
    if (this.state && this.state.message){
      return this.state.message;
    }

    return null;
  }
 
  public get title() : string {
    return this._title;
  }
  public set title(v : string) {
    this._title = v;
  }
  

   
   

  public get state(): any {
    return this._state;
  }
  public set state(v: any) {
    console.log(`${this._componentName}.state - set - v=`, v);
    this._state = v;
  }
}
